const mobileRE =
  /(android|bb\d+|meego).+mobile|armv7l|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|samsungbrowser.*mobile|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i;
const notMobileRE = /CrOS/;

const tabletRE = /android|ipad|playbook|silk/i;

export function isMobile(opts?: {
  ua?: string | { headers: { "user-agent": string } };
  tablet?: boolean;
  featureDetect?: boolean;
}): boolean {
  if (!opts) {
    opts = {};
  }
  let ua = opts.ua;
  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
  if (!ua && typeof navigator !== "undefined") {
    ua = navigator.userAgent;
  }

  if (
    ua != undefined &&
    typeof ua === "object" &&
    ua.headers != undefined &&
    typeof ua.headers["user-agent"] === "string"
  ) {
    ua = ua.headers["user-agent"];
  }
  if (typeof ua !== "string") {
    return false;
  }

  let result =
    (mobileRE.test(ua) && !notMobileRE.test(ua)) ||
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    (!!opts.tablet && tabletRE.test(ua));

  if (
    !result &&
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    opts.tablet &&
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    opts.featureDetect &&
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    navigator &&
    navigator.maxTouchPoints > 1 &&
    ua.indexOf("Macintosh") !== -1 &&
    ua.indexOf("Safari") !== -1
  ) {
    result = true;
  }

  return result;
}

export enum WeChatPlatform {
  Unknown = "unknown",
  PC = "pc",
  Mobile = "mobile",
  DevTools = "devtools",
}

export function checkWeChatEnvironment(): WeChatPlatform {
  const ua = window.navigator.userAgent.toLowerCase();
  if (/micromessenger/i.test(ua)) {
    if (/windowswechat/i.test(ua)) {
      return WeChatPlatform.PC;
    } else if (/macwechat/i.test(ua)) {
      return WeChatPlatform.PC;
    } else if (/android/i.test(ua) || /iphone|ipad|ipod/i.test(ua)) {
      return /wechatdevtools/i.test(ua)
        ? WeChatPlatform.DevTools
        : WeChatPlatform.Mobile;
    } else {
      return WeChatPlatform.Unknown;
    }
  } else if (/wechatdevtools/i.test(ua)) {
    return WeChatPlatform.DevTools;
  } else {
    return WeChatPlatform.Unknown;
  }
}

export function isWeChat(): boolean {
  return checkWeChatEnvironment() !== WeChatPlatform.Unknown;
}
